import { helpPath } from '@kontor/shared';

/**
 * Adresse der Webseite mit Anleitung und Preisen. Für Entwicklung und Tests lässt sie sich über VITE_WEBSITE_URL (zum Beispiel http://localhost:4321) umstellen.
 */
export const WEBSITE: string = ((import.meta.env.VITE_WEBSITE_URL as string | undefined) ?? 'https://wirkia.de').replace(/\/$/, '');

/** Anleitung zur Seite, auf der der Benutzer gerade ist (Zuordnung in packages/shared/src/help.ts) */
export const helpUrl = (pathname: string): string => `${WEBSITE}${helpPath(pathname)}`;

/** Übersicht der Anleitung mit Suche und Verzeichnis */
export const HELP_HOME = `${WEBSITE}/anleitung/`;

/** Der Bereich der Webseite, in dem das Paket erklärt wird und gebucht werden kann */
export const planUrl = (plan: string): string => `${WEBSITE}/preise/#paket-${plan}`;
